import script from "./LoginPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginPanel.vue?vue&type=script&setup=true&lang=ts"

import "./LoginPanel.vue?vue&type=style&index=0&id=2dde6f44&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dde6f44"]])

export default __exports__